module.exports = __webpack_public_path__ + "static/media/authorAvatar2.3755e353.jpeg";